import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { Constants, ItsrApiService, MixpanelService } from '../_services';
import { MixpanelTrackedFormComponent } from '../global';

@Component({
  templateUrl: 'forgotpassword.component.html'
})
export class ForgotpasswordComponent extends MixpanelTrackedFormComponent implements OnInit {
  data: any = null;
  userForm: FormGroup;
  showLoadingIconUser: boolean = false;
  formSuccessUser: boolean | null = null;
  displayErrorUser: string = '';
  questionForm: FormGroup;
  showLoadingIconQuestion: boolean = false;
  formSuccessQuestion: boolean | null = null;
  displayErrorQuestion: string = '';
  securityQuestion: any;
  userName: any;

  constructor(
    private route: ActivatedRoute,
    private itsrApiService: ItsrApiService,
    private titleService: Title,
    formBuilder: FormBuilder,
    mixpanelService: MixpanelService
  ) {
    super(undefined, mixpanelService);

    this.userForm = formBuilder.group({
      userName: [null, Validators.compose([
        Validators.required,
        Validators.pattern(Constants.RegEx.NonWhitespaceValue)
      ])]
    });

    this.questionForm = formBuilder.group({
      answer: [null, Validators.compose([
        Validators.required,
        // Validators.pattern(Constants.RegEx.NonWhitespaceValue)
      ])]
    });
  }

  ngOnInit(): void {
    this.data = this.route.snapshot.data;
    this.mixpanelService.trackPageView(this.data.content.windowTitle);
    this.titleService.setTitle(this.data.content.windowTitle);
  }

  applyValueTrim(control: AbstractControl): void {
    const trimmedValue = typeof control.value === 'string' && control.value.trim();
    if (typeof trimmedValue === 'string') {
      control.setValue(trimmedValue);
    }
  }

  submitUserForm(event: Event): void {
    event.preventDefault();

    if (!this.userForm.valid) {
      this.markAllFormFieldsTouched(this.userForm);
      this.setFocusOnFirstInvalidField();
      return;
    }

    this.showLoadingIconUser = true;
    this.userName = this.userForm.value.userName;

    const subscription = this.itsrApiService.getUserSecurityQuestion(this.userName)
      .subscribe(
        (response): void => {
          if (ItsrApiService.isErrorResponse(response)) {
            this.formSuccessUser = false;
            this.displayErrorUser = response.Errors[0].Message;
            return;
          }

          this.securityQuestion = response.body.SecurityQuestion;
          const timeoutId = setTimeout((): void => {
            clearTimeout(timeoutId);

            const elQuestionInput = document.getElementById('squestion');
            if (elQuestionInput) { elQuestionInput.focus(); }
          }, 1000);
        },
        undefined, // error handler
        (): void => {
          this.showLoadingIconUser = false;
          subscription.unsubscribe();
        }
      );
  }

  submitQuestionForm(event: Event): void {
    event.preventDefault();

    if (!this.questionForm.valid) {
      this.markAllFormFieldsTouched(this.questionForm);
      this.setFocusOnFirstInvalidField();
      document.getElementById('content-section').focus();
      return;
    }

    this.showLoadingIconQuestion = true;

    const requestBody = {
      Username: this.userName,
      securityQuestion: this.securityQuestion,
      Answer: this.questionForm.value.answer
    };

    const subscription = this.itsrApiService.postForgotPasswordEmail(requestBody)
      .subscribe(
        (response): void => {
          if (ItsrApiService.isErrorResponse(response)) {
            this.formSuccessQuestion = false;
            this.displayErrorQuestion = response.Errors[0].Message;
            return;
          }

          this.formSuccessQuestion = true;
          this.questionForm.reset();
        },
        undefined, // error handler
        (): void => {
          this.showLoadingIconQuestion = false;
          subscription.unsubscribe();
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/forgotpassword.component.ts